import { CustomerSimple, VisitAddress } from "@legacy-megarax/crm-contracts";

export const customerHasAddress = (
  customer: CustomerSimple,
): customer is Omit<CustomerSimple, "visitAddress"> & { visitAddress: VisitAddress } => customer.visitAddress !== null;
